import { IBreadcrumbItem } from "@cyber-range/cyber-range-lib-ui/dist_types";
import Config from "../config";
import { Ref, watch } from "vue";

export function usePageTitle<T extends IBreadcrumbItem|{ text?:string, name?:string }>(breadcrumbs: Ref<T[]>)
{
    watch(breadcrumbs, (newValue) =>
    {
        if(newValue && newValue.length >  0)
        {
            let title = [Config.APP_TITLE, ... newValue.map(b => b.text ? b.text : b.name)].reverse().join(' - ');

            document.title = title;
        }
        else
        {
            document.title = Config.APP_TITLE;
        }
    }, {immediate:true});
}